import { apiRoot } from './apiRoot';
export const apiPath = 'api/';

export const APP_HOST = apiRoot || 'localhost';

export const API_URL = `${APP_HOST}${apiPath}`;
export const JWT_TOKEN = 'jwt_token';
